import { createSwiper, withResize } from '../../components/swiper-init.js';

// Note: this swiper intentionally targets the 'is--blog' attribute set
// in Webflow on the Reports page (shared markup convention).
export function initSwiperReportsWithResize() {
  withResize(() => createSwiper('is--blog'));
}
